import { splitWords, observeSplitReveal } from '../../assets/js/utils/splitWords'

export default class DoubleImg {
  constructor(el) {
    this.el = el
    this.leftImg = el.querySelector('.double-img--left-img')
    this.rightImg = el.querySelector('.double-img--right-img')
    this.ticking = false
    this.init()
  }

  init() {
    const title = this.el.querySelector('.double-img--title')
    const text = this.el.querySelector('.double-img--text')

    let offset = 0
    if (title) {
      splitWords(title, offset)
      offset += title.querySelectorAll('.tt-word').length
    }
    if (text) splitWords(text, offset)

    observeSplitReveal(this.el)

    if (this.leftImg || this.rightImg) {
      window.addEventListener('scroll', () => this.onScroll(), { passive: true })
      this.parallax()
    }
  }

  onScroll() {
    if (this.ticking) return
    this.ticking = true
    requestAnimationFrame(() => {
      this.parallax()
      this.ticking = false
    })
  }

  parallax() {
    const rect = this.el.getBoundingClientRect()
    if (rect.bottom < 0 || rect.top > window.innerHeight) return

    const progress = rect.top
    // Parallax atténué sur mobile (rendu plus stable)
    const factor = window.innerWidth <= 768 ? 0.25 : 1

    if (this.leftImg) this.leftImg.style.transform = `translateY(${progress * 0.12 * factor}px)`
    if (this.rightImg) this.rightImg.style.transform = `translateY(${progress * 0.2 * factor}px)`
  }
}
